export const POST_METHOD = "POST";
export const DELETE_METHOD = "DELETE";

export const ContentTypeJson = {
	"Content-Type": "application/json",
};
